import Layout from '@/layout/index.vue';
export default [
  {
    // 打印
    path: '/printTemplate',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'printTemplateBillEdit',
        component: () => import('@/views/commonCenter/printTemplate/printTemplateBillEdit.vue'),
        name: 'PrintTemplateBillEdit',
        meta: { title: '新增小票模版', icon: '', noCache: true },
      },
      {
        path: 'shopTemplateView',
        component: () => import('@/views/headManag/headSettings/printtemplate/shopTemplateView.vue'),
        name: 'ShopTemplateView',
        meta: { title: '门店打印模板', icon: '', noCache: true },
      },
    ],
  },
];
